export default "__VITE_ASSET__Cs1Pl9LX__"